<div *ngIf="expenseFacade.deletedExpenseSkeletonsLoading$ | async">Loading...</div>
<div *ngIf="expenseFacade.deletedExpenseSkeletonsLoaded$ | async">
  <div *ngIf="expenseFacade.deletedExpenseSkeletons$ | async as expenseSkeletons">
    <div *ngIf="expenseSkeletons.length > 0; else noDeletedExpenseSkeletons">
      <mat-accordion>
        <mat-expansion-panel
          *ngFor="let expense of expenseSkeletons"
          (opened)="expenseFacade.loadExpenseAudit(expense.expenseId)"
        >
          <mat-expansion-panel-header>
            {{ expenseFacade.getExpenseCategoryTypeName(expense.expenseCategoryId) | async }}
            <span *ngIf="expense.transactionDate">
              &nbsp; - &nbsp;{{ expense.transactionDate | date : 'longDate' }}</span
            >
            <span *ngIf="expense.isDeleted">&nbsp;(Deleted)</span>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <sd-portal-audit-detail-list
              [loading]="expenseFacade.expenseAuditLoading$ | async"
              [loaded]="expenseFacade.expenseAuditLoaded$ | async"
              [audits]="expenseFacade.expenseAudit$ | async"
              [noAuditsMessage]="'No audit records for this expense'"
              (nextPage)="expenseFacade.loadNextPageExpenseAudit(expense.expenseId)"
            ></sd-portal-audit-detail-list>
          </ng-template>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <ng-template #noDeletedExpenseSkeletons> No deleted expenses to audit </ng-template>
  </div>
</div>
